<template>
  <el-row :gutter="10">
    <el-col :span="6">
      <left-table />
    </el-col>
    <el-col :span="18">
      <right-table />
    </el-col>
  </el-row>
</template>
<script>
import LeftTable from './components/left-table/index.vue'
import RightTable from './components/right-table/index.vue'
export default {
  name: 'researchInputTemplate',
  components: {
    LeftTable,
    RightTable,
  },
}
</script>

<!--<template>
  <div class="card-form">
    <div>
      <page-header
        @reset="reset"
        @add="add"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      />
    </div>
    <page-main
      ref="main"
      :table-data="table"
      :dictionary-type-table="dictionaryTypeTable"
      :loading="loading"
      @submit="reload"
      @submitByAttributeType="submitByAttributeType"
    />
    <js-pagination
      class="mt-2"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="sm"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  name: 'design-elementsDictionary',
  components: {
    PageHeader: () => import('./components/header/index'),
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      table: [],
      dictionaryTypeTable: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
      if (this.$refs.main) {
        this.$refs.main.resetParams()
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset()
    },
    submitByAttributeType(deAttributeType) {
      if (deAttributeType) {
        //点击左侧列表
        let form = {
          deAttributeType: deAttributeType
        }
        this.handleSubmit(form)
      } else {
        //新增属性类型后查询左侧列表
        this.loadDictionaryType()
      }
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .listDesignElementsDictionaryApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
      this.loadDictionaryType()
      if (this.$refs.main) {
        this.$refs.main.clearSelectAll()
      }
    },
    //加载设计素材属性类型列表
    loadDictionaryType() {
      this.$api
        .listDesignElementsDictionaryTypeApi()
        .then((res) => {
          this.dictionaryTypeTable = res.body.data
        })
        .catch(() => {})
    },
    add() {
      this.$refs.main.fromLoad('add')
    }
  }
}
</script>-->
